export class SelectorServiceOutputModel {
  inputId: string;
  parentCompName: string;
  labels: string[];
  isQuantityZero: boolean;
  isRewardMax: boolean;
  type: string;
  selectorType: string;
  value: number;
  eventValue: any; // can be a string if it is a label or number
  toggle: boolean;
  custGroupId: number;
  constructor() { }
}
